module.exports = __webpack_public_path__ + "static/media/video.97cfd882.webm";